/* eslint-disable complexity */
import React from 'react';
import { IconPopup, Typography } from '@adac-mp/components';
import { ViewportType } from '@adac-mp/components/src/hooks/useViewport';
import { IVehicleCategory, formatPlates } from '@adac-mp/shared';

export const renderCategoryCard = (
	title: string,
	flowId: number,
	categoryId?: string,
	viewport?: ViewportType,
	category?: IVehicleCategory,
) => {
	if (category) {
		const { id, name, licenseplate, categoryName, description, shortText, renderIcon } = category;
		const formattedId = licenseplate ? `${String(id)}-${licenseplate}` : String(id);
		const hasInfoIDrawer = viewport === 'mobile' && description && (flowId === 7 || flowId === 0);
		const hasDescriptionText = (flowId === 7 || flowId === 0) && viewport === 'desktop' && description;
		const hasShortText = flowId === 0 && viewport === 'mobile' && shortText;
		return (
			<span className="flex flex-col items-center text-center">
				{flowId === 7 && categoryName && (
					<Typography
						size="xsSm"
						variant="title"
						color="title"
						className={`absolute top-0 -translate-y-1/2 inline-flex items-center h-3.5 px-1 ${
							categoryId === formattedId ? 'bg-primary' : 'bg-gray-600'
						}`}>
						{categoryName}
					</Typography>
				)}
				{hasInfoIDrawer && (
					<span className="absolute right-3">
						{renderIcon && (
							<IconPopup
								bold
								type="info"
								title={title}
								paddingX="large"
								buttonStyle="bg-white"
								content={{
									title: name,
									content: (
										<>
											{renderIcon()}
											<br /> {description}
										</>
									),
								}}
							/>
						)}
					</span>
				)}
				<span className="flex flex-col gap-2 items-center">
					{renderIcon && renderIcon(categoryId === formattedId)}
					<span className="flex flex-col">
						<Typography variant="title" color="title" size="lg">
							{name}
						</Typography>
						{licenseplate && (
							<Typography color="title" size="lg">
								{formatPlates(licenseplate)}
							</Typography>
						)}
					</span>
					{hasDescriptionText && <Typography color="lightText">{description}</Typography>}
					{hasShortText && <Typography color="lightText">{shortText}</Typography>}
				</span>
			</span>
		);
	}
	return null;
};
